<form #form="ngForm" class="login-form">
  <mat-form-field class="fullwidth" appearance="outline" [class.error-margin]="inputCpf.touched && inputCpf?.errors" >
    <mat-label>CPF</mat-label>
    <input
      id="inputCpf"
      name="inputCpf"
      type="text"
      #inputCpf="ngModel"
      [(ngModel)]="usuario.cpf"
      [modelSemMascara]="true"
      mascara="000.000.000-00"
      matInput
      placeholder="000.000.000-00" 
      required
      document-validator
      (focus)="setFocus('inputCpf')"
      (blur)="removeFocus('inputCpf')">
      <button
        *ngIf="(hasFocus('inputCpf') || hasFocus('cancel-inputCpf')) && inputCpf.control.value?.length > 0" 
        mat-icon-button 
        matSuffix
        class="cancel-icon"
        type="button"
        (mouseover)="setFocus('cancel-inputCpf')"
        (mouseleave)="removeFocus('cancel-inputCpf')"
        (click)="clearField(inputCpf.control,'cancel-inputCpf')">
        <mat-icon >cancel</mat-icon>
      </button>
      <mat-error *ngIf="inputCpf.touched && inputCpf.getError('required')">
        <mat-icon class="material-symbols-outlined mat-icon-error">error</mat-icon>
        Informe o número de CPF
      </mat-error>
      <mat-error *ngIf="inputCpf.touched && inputCpf.getError('documentIsInvalid')">
        <mat-icon class="material-symbols-outlined mat-icon-error">error</mat-icon>
        Informe um CPF válido
      </mat-error>
  </mat-form-field>

  <mat-form-field class="fullwidth" appearance="outline" [class.error-margin]="inputDataNascimento.touched && inputDataNascimento?.errors">
    <mat-label>Data de nascimento</mat-label>
    <input 
      matInput 
      name="inputDataNascimento"
      #inputDataNascimento="ngModel"
      [(ngModel)]="usuario.dataNascimento"
      mascara="00/00/0000"
      placeholder="00/00/0000" 
      autocomplete="off"
      required
      date-validator
      (focus)="setFocus('inputDataNascimento')"
      (blur)="removeFocus('inputDataNascimento')">
      <button
        *ngIf="(hasFocus('inputDataNascimento') || hasFocus('cancel-inputDataNascimento')) && inputDataNascimento.control.value?.length > 0" 
        mat-icon-button 
        matSuffix
        class="cancel-icon"
        type="button"
        (mouseover)="setFocus('cancel-inputDataNascimento')"
        (mouseleave)="removeFocus('cancel-inputDataNascimento')"
        (click)="clearField(inputDataNascimento.control,'cancel-inputDataNascimento')">
        <mat-icon >cancel</mat-icon>
      </button>
      <mat-error *ngIf="inputDataNascimento.touched && inputDataNascimento?.errors?.required">
        <mat-icon class="material-symbols-outlined mat-icon-error">error</mat-icon>
        Informe a data de nascimento
      </mat-error>
      <mat-error *ngIf="inputDataNascimento.touched && inputDataNascimento?.errors?.invalidDate">
        <mat-icon class="material-symbols-outlined mat-icon-error">error</mat-icon>
        Informe uma data válida
      </mat-error>
  </mat-form-field>

  <div class="actions">
    <button 
      type="submit"
      mat-flat-button
      [disabled]="form.invalid || loading"
      class="fullwidth"
      (click)="handleLogin()">
      <mat-icon *ngIf="loading">
        <mat-spinner color="primary" diameter="20">
        </mat-spinner>
      </mat-icon>
      Continuar
    </button>

    <button 
      type="button"
      mat-stroked-button
      [disabled]="loading"
      class="outlined"
      (click)="handleLogout()"
      color="primary">
      Sair
    </button>
    
  </div>
</form>